import filesize from "filesize";

export const formatFileSize = (bytes: number | string) => {
  return filesize(parseInt(bytes + "", 10));
};
